/** @enum {string} */
const ImportSource = {
  EXCEL: 'Excel',
  JIRA: 'JIRA',
};

export { ImportSource };
